import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/schedly/calcom/apps/web/modules/apps/[slug]/slug-view.tsx");
